import { IsCyo, MenuRecipe } from '@/menu/pizza/pizzaMenuTypes';
import { availability } from './nationalDataHelpers';

/* eslint-disable @typescript-eslint/explicit-module-boundary-types */
const pizzaData = (): MenuRecipe[] => {
  const pizzaNational = [
    {
      id: '0',
      name: 'Cheese Pizza',
      isCYO: IsCyo.FALSE,
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_CHEESE.jpg',
      productDescription:
        'Your favorite cheese pizza, with your choice of crust covered in classic marinara sauce and topped with gooey mozzarella cheese. It\'s anything but "plain."',
      outOfStock: false,
      priority: 0,
      vegetarian: true,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '1',
      isCYO: IsCyo.FALSE,
      name: 'Pepperoni Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_PEPPERONI.jpg',
      productDescription: 'You literally can\'t go wrong with pepperoni and mozzarella cheese. Classic for a reason.',
      outOfStock: false,
      priority: 1,
      vegetarian: false,
      staticLink: 'https://www.pizzahut.com/c/content/pepperoni-pizza',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '2',
      isCYO: IsCyo.FALSE,
      name: 'Supreme Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_SUPREME.jpg',
      productDescription:
      'This loaded pizza is the perfect choice for family dinner or a lunch with your crew. Includes pepperoni, seasoned pork, beef, mushrooms, green bell peppers and onions.',
      outOfStock: false,
      priority: 2,
      vegetarian: false,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '3',
      isCYO: IsCyo.FALSE,
      name: 'Meat Lover’s® Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_MEAT_LOVERS.jpg',
      productDescription:
      'Packed with pepperoni, Italian sausage, ham, bacon, seasoned pork and beef, this pizza is NOT messing around.',
      outOfStock: false,
      priority: 3,
      vegetarian: false,
      staticLink: 'https://www.pizzahut.com/c/content/meat-lovers-pizza',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '4',
      isCYO: IsCyo.FALSE,
      name: 'Pepperoni Lover’s® Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_PEPPERONI_LOVERS.jpg',
      productDescription:
      'Ever wished your pepperoni pizza had more pepperoni? Of course you did. This oven-hot pizza has 50% more pepperoni than our average pizza pie.',
      outOfStock: false,
      priority: 4,
      vegetarian: false,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '5',
      isCYO: IsCyo.FALSE,
      name: 'Veggie Lover’s® Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_VEGGIE_LOVERS.jpg',
      productDescription: "A garden's worth of vegetables. Mushrooms, onions, crisp green peppers, tomatoes and black olives.",
      outOfStock: false,
      priority: 5,
      vegetarian: true,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '6',
      isCYO: IsCyo.FALSE,
      name: 'Backyard BBQ Chicken Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_BBQ_CHICKEN_PIZZA_DIP.jpg',
      productDescription:
      "This BBQ pizza comes topped with grilled chicken, bacon and red onion. Who's the grillmaster now?",
      outOfStock: false,
      priority: 6,
      vegetarian: false,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '7',
      isCYO: IsCyo.FALSE,
      name: 'Buffalo Chicken Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_BUFFALO_CHICKEN.jpg',
      productDescription:
      'We took your favorite food and put it on a pizza. With tangy buffalo sauce, tender chicken and banana peppers, this beautiful masterpiece tastes like a football game feels.',
      outOfStock: false,
      priority: 7,
      vegetarian: false,
      staticLink: 'https://www.pizzahut.com/c/content/buffalo-chicken-pizza',
      imageAltText: '',
      hidden: false,
      availability
    },
    {
      id: '8',
      isCYO: IsCyo.FALSE,
      name: 'Hawaiian Chicken Pizza',
      imageURL: '/images/nationalMenu/pizza/Pizza_ProductTile_HAWAIIAN_CHICKEN.jpg',
      productDescription:
      "Give your taste buds a tropical vacation with this amped up Hawaiian pizza. It's got tasty chicken, ham, pineapple AND green peppers.",
      outOfStock: false,
      priority: 8,
      vegetarian: false,
      staticLink: '#',
      imageAltText: '',
      hidden: false,
      availability
    }
  ];

  return pizzaNational;
};
/* eslint-enable @typescript-eslint/explicit-module-boundary-types */

export default pizzaData;
